export const REFERRAL_SOURCE_DEFAULT_SORT = {
  sortedColumn: 'name',
  sortedColumnOrder: 'ascend'
}
